export class GlobalSearchService {
    static serviceName = 'globalSearchService';

    search(searchQuery: string) {
        if(!searchQuery) {
            return;
        }

        const constructedUrl = this.constructUrl(searchQuery);
        window.location.href = constructedUrl.toString();
    }

    constructUrl(searchQuery: string) {
        const url = new URL('/search', window.location.origin);
        const params = {type: 'global', q: searchQuery};
        url.search = new URLSearchParams(params).toString();
        return url;
    }
}